/* Tab switching for the tabbed mega-menu panel (snippets/mega-menu-tabs.liquid).
   All tab panels are pre-rendered in the DOM; clicking a rail button only moves the
   "is-active" class between sibling panels. The panel resets to the first tab every
   time the parent disclosure opens. */

if (!window.customElements.get('mega-menu-tabs')) {
  class MegaMenuTabs extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('.mega-menu__tab-button');

          if (button) {
            this.select(this.buttons.indexOf(button));
          }
        },
        { signal }
      );

      this.closest('details')?.addEventListener(
        'toggle',
        (event) => {
          if (event.target.open) {
            this.select(0);
          }
        },
        { signal }
      );

      if (window.Shopify && window.Shopify.designMode) {
        // Reveal the tab containing a tile or note block when it is selected in the theme editor
        // (the surrounding disclosure is opened by the stock CustomDetails block-select handler)
        this.addEventListener(
          'shopify:block:select',
          (event) => {
            const panel = event.target.closest('.mega-menu__tab-panel');

            if (panel) {
              this.select(this.panels.indexOf(panel));
            }
          },
          { signal }
        );
      }

      this.select(0);
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    get buttons() {
      return Array.from(this.querySelectorAll('.mega-menu__tab-button'));
    }

    get panels() {
      return Array.from(this.querySelectorAll('.mega-menu__tab-panel'));
    }

    select(index) {
      if (index < 0) {
        return;
      }

      this.buttons.forEach((button, i) => button.setAttribute('aria-expanded', i === index ? 'true' : 'false'));
      this.panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
    }
  }

  window.customElements.define('mega-menu-tabs', MegaMenuTabs);
}
